import React from 'react';

const FormTitle = ({ label, labelClassName, forComponent }) => {
  const labelClassNameF = (labelClassName || "form-title");
  return (
    <div className={labelClassNameF + "-outer"}>{label}
    <label class={labelClassNameF + "-switch"} for={forComponent}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 15L12 9L18 15" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    </label>
    </div>
  );
};

export default FormTitle;